



















import Vue from 'vue';

import SocialIcons from '@/components/layout/SocialIcons.vue';
import {eventBus} from '@/event-bus';


export default Vue.extend({
  name: 'sidebar',
  components: {
    SocialIcons,
  },
  data () {
    return {
      eventBus,
      sidebarIsOpen: false,
      SocialIcons,
      navItems: [
        {title: 'Home', hash: '#about'},
        {title: 'Services', hash: '#services'},
        {title: 'Friends', hash: '#testimonials'},
        {title: 'Gallery', hash: '#gallery'},
        {title: 'Contact Me', hash: '#contact'},
      ],
    };
  },

  methods: {
    itemClicked () {
      this.sidebarIsOpen = false;
    },
  },

  created () {
    this.eventBus.$on('open-sidebar', () => {
      this.sidebarIsOpen = true;
    });
  },
});
